
import { defineComponent } from 'vue'
import IndexForm from '../../components/form/productindex/IndexForm.vue'
import store, { ActionTypes } from '../../store'
import { mapState } from 'vuex'

export default defineComponent({
  name: 'StrategyCopy',
  components: {
    IndexForm
  },
  beforeRouteEnter (to, from, next) {
    const { id } = to.params
    store.dispatch(ActionTypes.RESET_INDEX).then(() =>
        store.dispatch(ActionTypes.FETCH_COPY_INDEX, id).then(() => next())
    )
  },
  beforeRouteUpdate (to, from, next) {
    const { id } = to.params
    store.dispatch(ActionTypes.RESET_INDEX).then(() =>
        store.dispatch(ActionTypes.FETCH_COPY_INDEX, id).then(() => next())
    )
  },
  computed: {
    ...mapState([
      'index'
    ])
  },

})
